import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CustomFieldVisibilityIcon",
  props: {
    visibilityType: {
      type: String,
      required: true,
      validator(value) {
        var _context;
        return _includesInstanceProperty(_context = ["none", "compact", "full"]).call(_context, value);
      }
    }
  },
  computed: {
    visibilityIcon() {
      const iconMap = {
        none: "fa-eye-slash",
        compact: "fa-tag",
        full: "fa-eye"
      };
      return iconMap[this.visibilityType];
    }
  }
});